import { AiToneAndVoiceSettingsUpdateSchema } from "@redotech/redo-model/ai-tone-and-voice";
import * as z from "zod";

const updateAiToneAndVoiceSettingsOutput = z.object({ success: z.boolean() });

export const updateAiToneAndVoiceSettings: {
  name: "updateAiToneAndVoiceSettings";
  input: typeof AiToneAndVoiceSettingsUpdateSchema;
  output: typeof updateAiToneAndVoiceSettingsOutput;
} = {
  name: "updateAiToneAndVoiceSettings" as const,
  input: AiToneAndVoiceSettingsUpdateSchema,
  output: updateAiToneAndVoiceSettingsOutput,
};
